/* Holasticker · editor de camisetas
   ---------------------------------------------------------------------------
   Misma base que hs-llavero.js, adaptada a camiseta:
   - El diseno se coloca sobre una camiseta del color elegido, dentro de la
     zona de impresion: logo pequeno en el pecho y diseno grande en la
     espalda. Las dos van incluidas en el pack.
   - La espalda se puede dejar sin diseno si el cliente lo dice expresamente.
   - No se compra hasta tener el pecho listo, la espalda decidida y las
     tallas repartidas (eso lo lleva el bloque de opciones: HSCamOpts).

   Reglas de la casa:
   - Todo va dentro de try/catch: si algo falla, comprar debe seguir igual.
   - El lienzo que ve el cliente y el que se exporta salen de la misma
     funcion de dibujo.
*/
(function () {
  'use strict';

  if (window.HSCamiseta) return;

  var EXPORT_MAX = 1000;
  var ZOOM_MIN = 0.2, ZOOM_MAX = 6;
  var ROSA = '#ff4d94';

  var CAMPOS = {
    A: { archivo: 'properties[Diseño delantero]', previa: 'properties[_vista_previa]',         nombre: 'Delante', largo: 'Delante (pecho)' },
    B: { archivo: 'properties[Diseño trasero]',   previa: 'properties[_vista_previa_trasera]', nombre: 'Detrás',  largo: 'Detrás (espalda)' }
  };
  var PROP_ENCUADRE = 'properties[_encuadre]';
  var PROP_SIN_TRASERA = 'properties[Espalda]';
  /* Si el cliente no tiene el logo a mano, compra igual y lo manda despues. */
  var PROP_DESPUES = 'properties[Envío del diseño]';
  var TXT_DESPUES = 'Lo envío después (email o WhatsApp)';

  /* --- Camiseta --------------------------------------------------------------
     Silueta en una caja de 1000 x 1000, la misma que usan las fotos del
     producto. Zonas de impresion PROVISIONALES (DTF): pecho ~10 x 10 cm,
     espalda ~A3. */

  var SILUETA = {
    A: 'M385 95Q500 185 615 95L735 125Q850 170 945 330L830 410Q790 370 765 350L775 950Q500 975 225 950L235 350Q210 370 170 410L55 330Q150 170 265 125Z',
    B: 'M385 95Q500 125 615 95L735 125Q850 170 945 330L830 410Q790 370 765 350L775 950Q500 975 225 950L235 350Q210 370 170 410L55 330Q150 170 265 125Z'
  };
  var CUELLO_DENTRO = 'M385 95Q500 125 615 95Q500 185 385 95Z';
  var RIBETE = { A: 'M392 101Q500 200 608 101', B: 'M392 100Q500 138 608 100' };
  var SISAS = ['M735 125Q722 250 765 350', 'M265 125Q278 250 235 350'];
  var ZONAS = { A: { x: 575, y: 215, w: 130, h: 130 }, B: { x: 350, y: 200, w: 300, h: 424 } };

  /* --- Utilidades --------------------------------------------------------- */

  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto != null) n.textContent = texto;
    return n;
  }

  function boton(txt, clase) {
    var b = el('button', clase, txt);
    b.type = 'button';
    return b;
  }

  function limitar(v, min, max) { return v < min ? min : (v > max ? max : v); }

  function radio(grupo) {
    return document.querySelector('[data-hs-group="' + grupo + '"]:checked');
  }

  function etiqueta(grupo, porDefecto) {
    var r = radio(grupo);
    return r ? r.dataset.hsLabel : porDefecto;
  }

  function colorActual() {
    var r = radio('color');
    return (r && r.dataset.hsHex) || '#f4f4f2';
  }

  function formularioCompra() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function ponerArchivo(nombre, file) {
    var f = formularioCompra();
    if (!f) return false;
    var input = f.querySelector('input[type="file"][name="' + nombre + '"][data-hs-generado]');
    if (!file) { if (input) input.remove(); return true; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'file';
      input.name = nombre;
      input.hidden = true;
      input.setAttribute('data-hs-generado', '');
      f.appendChild(input);
    }
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
    } catch (e) { return false; }
    f.setAttribute('enctype', 'multipart/form-data');
    return true;
  }

  function ponerTexto(nombre, valor) {
    var f = formularioCompra();
    if (!f) return;
    var input = f.querySelector('input[type="hidden"][name="' + nombre + '"]');
    if (valor == null || valor === '') { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = nombre;
      f.appendChild(input);
    }
    input.value = valor;
  }

  /* Tono de las costuras segun lo claro que sea el color. */
  function hexRgb(h) {
    h = h.replace('#', '');
    return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
  }
  function claro(h) { var c = hexRgb(h); return (c[0] * 299 + c[1] * 587 + c[2] * 114) / 1000 > 150; }
  function tono(h, f) {
    var c = hexRgb(h);
    return 'rgb(' + c.map(function (v) { return Math.max(0, Math.min(255, Math.round(v * f))); }).join(',') + ')';
  }

  /* --- Estado --------------------------------------------------------------
     Una ficha por cara. estado: ninguno | pendiente | sin-previa | listo
     En la espalda, ademas: omitida (el cliente la deja sin diseno). */

  function caraVacia() {
    return { img: null, nombre: '', t: { escala: 1, x: 0, y: 0, giro: 0 }, guardado: false, estado: 'ninguno' };
  }

  var caras = { A: caraVacia(), B: caraVacia() };
  var activa = 'A';
  var combinacionOk = true;
  var despues = false;
  var inputs = { A: null, B: null };

  var modal = null, lienzo = null, ctx = null, zoomInput = null, subtitulo = null;
  var pestanas = null, vacio = null, bGuardar = null, avisoZona = null;

  function inputDe(cara) {
    if (!inputs[cara]) {
      inputs[cara] = document.querySelector('input[type="file"][data-hs-input="' + cara + '"]');
    }
    return inputs[cara];
  }

  /* --- Dibujo -------------------------------------------------------------- */

  function dibujar(c, w, h, cara, conGuia) {
    var k = w / 1000;
    var col = colorActual();
    var z = ZONAS[cara];
    var d = caras[cara];

    c.clearRect(0, 0, w, h);
    c.save();
    c.scale(k, k);

    var cuerpo = new Path2D(SILUETA[cara]);
    c.save();
    c.shadowColor = 'rgba(0,0,0,0.18)';
    c.shadowBlur = 24;
    c.shadowOffsetY = 10;
    c.fillStyle = col;
    c.fill(cuerpo);
    c.restore();

    var linea = claro(col) ? tono(col, 0.8) : tono(col, 1.6);
    if (cara === 'A') { c.fillStyle = tono(col, 0.82); c.fill(new Path2D(CUELLO_DENTRO)); }
    c.strokeStyle = linea;
    c.lineWidth = 3;
    c.stroke(cuerpo);
    c.lineWidth = 4;
    c.stroke(new Path2D(RIBETE[cara]));
    c.lineWidth = 2.5;
    SISAS.forEach(function (s) { c.stroke(new Path2D(s)); });

    if (d.img) {
      c.save();
      c.beginPath();
      c.rect(z.x, z.y, z.w, z.h);
      c.clip();
      /* "contain": el logo entero cabe en la zona al abrir. */
      var base = Math.min(z.w / d.img.naturalWidth, z.h / d.img.naturalHeight);
      var e = base * d.t.escala;
      c.translate(z.x + z.w / 2 + d.t.x * z.w, z.y + z.h / 2 + d.t.y * z.h);
      c.rotate(d.t.giro * Math.PI / 180);
      c.imageSmoothingQuality = 'high';
      c.drawImage(d.img,
        -d.img.naturalWidth * e / 2, -d.img.naturalHeight * e / 2,
        d.img.naturalWidth * e, d.img.naturalHeight * e);
      c.restore();
    }

    if (conGuia) {
      c.save();
      c.setLineDash([16, 11]);
      c.lineWidth = 5;
      c.strokeStyle = 'rgba(255,255,255,0.85)';
      c.strokeRect(z.x, z.y, z.w, z.h);
      c.lineWidth = 3.5;
      c.strokeStyle = ROSA;
      c.strokeRect(z.x, z.y, z.w, z.h);
      c.restore();
    }

    c.restore();
  }

  function repintar() {
    if (!lienzo || !ctx) return;
    dibujar(ctx, lienzo.width, lienzo.height, activa, true);
  }

  function medirLienzo() {
    if (!lienzo) return;
    var caja = lienzo.parentElement;
    var pad = 20;
    var dispW = Math.max(160, caja.clientWidth - pad);
    var dispH = Math.max(160, Math.round(window.innerHeight * 0.42));
    var lado = Math.min(dispW, dispH);

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    lienzo.style.width = Math.round(lado) + 'px';
    lienzo.style.height = Math.round(lado) + 'px';
    lienzo.width = Math.round(lado * dpr);
    lienzo.height = Math.round(lado * dpr);
    repintar();
  }

  /* --- Gestos: arrastrar, pellizcar y rueda --------------------------------- */

  function conectarGestos() {
    var arrastrando = false, px = 0, py = 0;
    var punteros = {}, distIni = 0, escalaIni = 1;

    function t() { return caras[activa].t; }

    lienzo.addEventListener('pointerdown', function (e) {
      if (!caras[activa].img) return;
      lienzo.setPointerCapture(e.pointerId);
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(punteros);
      if (ids.length === 1) {
        arrastrando = true; px = e.clientX; py = e.clientY;
      } else if (ids.length === 2) {
        arrastrando = false;
        distIni = separacion(punteros, ids);
        escalaIni = t().escala;
      }
    });

    lienzo.addEventListener('pointermove', function (e) {
      if (!punteros[e.pointerId]) return;
      punteros[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(punteros);

      if (ids.length >= 2 && distIni > 0) {
        t().escala = limitar(escalaIni * (separacion(punteros, ids) / distIni), ZOOM_MIN, ZOOM_MAX);
        if (zoomInput) zoomInput.value = String(t().escala);
        repintar();
        return;
      }
      if (!arrastrando) return;
      /* El desplazamiento se mide sobre la zona de impresion. */
      var r = lienzo.getBoundingClientRect();
      var z = ZONAS[activa];
      t().x += (e.clientX - px) / Math.max(1, r.width * z.w / 1000);
      t().y += (e.clientY - py) / Math.max(1, r.height * z.h / 1000);
      px = e.clientX; py = e.clientY;
      repintar();
    });

    function soltar(e) {
      delete punteros[e.pointerId];
      if (Object.keys(punteros).length < 2) distIni = 0;
      if (Object.keys(punteros).length === 0) arrastrando = false;
    }
    lienzo.addEventListener('pointerup', soltar);
    lienzo.addEventListener('pointercancel', soltar);

    lienzo.addEventListener('wheel', function (e) {
      if (!caras[activa].img) return;
      e.preventDefault();
      t().escala = limitar(t().escala * (e.deltaY < 0 ? 1.08 : 0.925), ZOOM_MIN, ZOOM_MAX);
      if (zoomInput) zoomInput.value = String(t().escala);
      repintar();
    }, { passive: false });
  }

  function separacion(p, ids) {
    var a = p[ids[0]], b = p[ids[1]];
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  /* --- Modal -------------------------------------------------------------- */

  function construir() {
    modal = el('div', 'hs-ed hs-ed--llavero hs-ed--camiseta');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Ajusta tu diseño');
    modal.hidden = true;

    var fondo = el('div', 'hs-ed__fondo');
    var panel = el('div', 'hs-ed__panel');

    var cab = el('div', 'hs-ed__cab');
    var tit = el('div', 'hs-ed__tit');
    tit.appendChild(el('h2', 'hs-ed__h', 'Ajusta tu diseño'));
    subtitulo = el('p', 'hs-ed__sub', '');
    tit.appendChild(subtitulo);
    var cerrar = el('button', 'hs-ed__x', '×');
    cerrar.type = 'button';
    cerrar.setAttribute('aria-label', 'Cerrar');
    cab.appendChild(tit);
    cab.appendChild(cerrar);

    pestanas = el('div', 'hs-ed__caras');
    pestanas.setAttribute('role', 'tablist');
    ['A', 'B'].forEach(function (k) {
      var b = boton(CAMPOS[k].largo, 'hs-ed__cara');
      b.setAttribute('role', 'tab');
      b.setAttribute('data-hs-cara', k);
      b.appendChild(el('span', 'hs-ed__caraok', '✓'));
      b.addEventListener('click', function () { cambiarCara(k); });
      pestanas.appendChild(b);
    });

    var escena = el('div', 'hs-ed__escena');
    lienzo = document.createElement('canvas');
    lienzo.className = 'hs-ed__lienzo';
    ctx = lienzo.getContext('2d');
    escena.appendChild(lienzo);

    vacio = el('div', 'hs-ed__vacio');
    vacio.hidden = true;
    vacio.appendChild(el('p', 'hs-ed__vaciotxt', 'La espalda va incluida: sube aquí el diseño grande (tu logo, tu web, el nombre del evento…).'));
    var bSubirB = boton('Subir diseño de la espalda', 'hs-ed__b hs-ed__b--fuerte');
    bSubirB.addEventListener('click', function () { var i = inputDe(activa); if (i) i.click(); });
    vacio.appendChild(bSubirB);
    var bSinB = boton('No quiero nada detrás', 'hs-ed__b hs-ed__b--plano');
    bSinB.addEventListener('click', function () { omitirEspalda(true); cerrarModal(); });
    vacio.appendChild(bSinB);
    escena.appendChild(vacio);

    avisoZona = el('p', 'hs-ed__aviso', '');

    var mandos = el('div', 'hs-ed__mandos');
    var filaZoom = el('label', 'hs-ed__zoom');
    filaZoom.appendChild(el('span', 'hs-ed__zoomtxt', 'Zoom'));
    zoomInput = document.createElement('input');
    zoomInput.type = 'range';
    zoomInput.min = String(ZOOM_MIN);
    zoomInput.max = String(ZOOM_MAX);
    zoomInput.step = '0.01';
    zoomInput.value = '1';
    zoomInput.className = 'hs-ed__rango';
    filaZoom.appendChild(zoomInput);
    mandos.appendChild(filaZoom);

    var botones = el('div', 'hs-ed__acciones');
    var bGirar = boton('Girar 90°', 'hs-ed__b');
    var bCentrar = boton('Centrar', 'hs-ed__b');
    var bOtro = boton('Cambiar imagen', 'hs-ed__b');
    botones.appendChild(bGirar);
    botones.appendChild(bCentrar);
    botones.appendChild(bOtro);
    mandos.appendChild(botones);

    var pie = el('div', 'hs-ed__pie');
    var bCancelar = boton('Cancelar', 'hs-ed__b hs-ed__b--plano');
    bGuardar = boton('Guardar vista previa', 'hs-ed__b hs-ed__b--fuerte');
    pie.appendChild(bCancelar);
    pie.appendChild(bGuardar);

    panel.appendChild(cab);
    panel.appendChild(pestanas);
    panel.appendChild(escena);
    panel.appendChild(avisoZona);
    panel.appendChild(mandos);
    panel.appendChild(pie);
    modal.appendChild(fondo);
    modal.appendChild(panel);
    document.body.appendChild(modal);

    fondo.addEventListener('click', cerrarModal);
    cerrar.addEventListener('click', cerrarModal);
    bCancelar.addEventListener('click', cerrarModal);
    bGuardar.addEventListener('click', guardar);
    bGirar.addEventListener('click', function () {
      var t = caras[activa].t; t.giro = (t.giro + 90) % 360; repintar();
    });
    bCentrar.addEventListener('click', function () {
      caras[activa].t = { escala: 1, x: 0, y: 0, giro: 0 };
      if (zoomInput) zoomInput.value = '1';
      repintar();
    });
    bOtro.addEventListener('click', function () { var i = inputDe(activa); if (i) i.click(); });
    zoomInput.addEventListener('input', function () {
      caras[activa].t.escala = parseFloat(zoomInput.value) || 1;
      repintar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) cerrarModal();
    });
    window.addEventListener('resize', function () { if (modal && !modal.hidden) medirLienzo(); });

    conectarGestos();
  }

  function caraHecha(k) {
    var e = caras[k].estado;
    return caras[k].guardado || e === 'sin-previa' || e === 'omitida';
  }

  function pintarModal() {
    if (!modal) return;
    subtitulo.textContent = etiqueta('pack', '') + ' · ' + etiqueta('color', '') + ' · ' + CAMPOS[activa].largo;

    pestanas.querySelectorAll('[data-hs-cara]').forEach(function (b) {
      var k = b.getAttribute('data-hs-cara');
      var on = k === activa;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.classList.toggle('is-hecha', caraHecha(k));
    });

    var hay = !!caras[activa].img;
    vacio.hidden = hay;
    ['.hs-ed__mandos', '.hs-ed__pie'].forEach(function (s) {
      var n = modal.querySelector(s);
      if (n) n.style.display = hay ? '' : 'none';
    });
    if (zoomInput) zoomInput.value = String(caras[activa].t.escala);

    avisoZona.textContent = activa === 'A'
      ? 'Pecho: logo pequeño, unos 10 × 10 cm. La línea rosa marca la zona de impresión.'
      : 'Espalda: diseño grande, hasta tamaño A3. La línea rosa marca la zona de impresión.';

    var falta = activa === 'A' && !caraHecha('B');
    bGuardar.textContent = falta ? 'Guardar y seguir con la espalda' : 'Guardar vista previa';
  }

  function abrirModal() {
    if (!modal) construir();
    modal.hidden = false;
    document.body.classList.add('hs-ed-abierto');
    pintarModal();
    requestAnimationFrame(medirLienzo);
  }

  function cerrarModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('hs-ed-abierto');
  }

  function cambiarCara(k) {
    activa = k;
    pintarModal();
    medirLienzo();
  }

  /* --- Carga de imagen ---------------------------------------------------- */

  function cargar(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\//.test(file.type)) return reject(new Error('no-imagen'));
      var url = URL.createObjectURL(file);
      var i = new Image();
      i.onload = function () {
        if (!i.naturalWidth) { URL.revokeObjectURL(url); return reject(new Error('sin-tamano')); }
        resolve(i);
      };
      i.onerror = function () { URL.revokeObjectURL(url); reject(new Error('carga')); };
      i.src = url;
    });
  }

  /* --- Guardar ------------------------------------------------------------ */

  function exportar(cara) {
    var c = document.createElement('canvas');
    c.width = EXPORT_MAX; c.height = EXPORT_MAX;
    /* Sin la linea rosa: es solo una guia, no se imprime. */
    dibujar(c.getContext('2d'), EXPORT_MAX, EXPORT_MAX, cara, false);
    return new Promise(function (resolve) { c.toBlob(resolve, 'image/png'); });
  }

  function escribirEncuadre() {
    var datos = { color: etiqueta('color', '') };
    ['A', 'B'].forEach(function (k) {
      var d = caras[k];
      if (!d.img) return;
      datos[k === 'A' ? 'delante' : 'detras'] = {
        escala: Math.round(d.t.escala * 1000) / 1000,
        x: Math.round(d.t.x * 1000) / 1000,
        y: Math.round(d.t.y * 1000) / 1000,
        giro: d.t.giro,
        origen: d.nombre
      };
    });
    ponerTexto(PROP_ENCUADRE, JSON.stringify(datos));
  }

  function guardarCara(cara) {
    return exportar(cara).then(function (blob) {
      if (!blob) return false;
      var nombre = cara === 'A' ? 'vista-previa-delante.png' : 'vista-previa-detras.png';
      var ok = ponerArchivo(CAMPOS[cara].previa, new File([blob], nombre, { type: 'image/png' }));
      if (ok) {
        caras[cara].guardado = true;
        caras[cara].estado = 'listo';
        escribirEncuadre();
        pintarMiniatura(cara, blob);
      }
      return ok;
    });
  }

  function guardar() {
    var cara = activa;
    if (!caras[cara].img) { cerrarModal(); return; }
    guardarCara(cara).then(function (ok) {
      refrescarCandado();
      if (ok && cara === 'A' && !caraHecha('B')) { cambiarCara('B'); return; }
      cerrarModal();
    }).catch(function () { cerrarModal(); });
  }

  /* Si cambia el color, las vistas previas guardadas se rehacen solas. */
  function regenerar() {
    ['A', 'B'].forEach(function (k) {
      if (caras[k].img && caras[k].guardado) guardarCara(k).catch(function () {});
    });
  }

  function pintarMiniatura(cara, blob) {
    var fila = document.querySelector('[data-hs-fila="' + cara + '"]');
    if (!fila) return;
    var thumb = fila.querySelector('[data-hs-thumb]');
    if (thumb) {
      if (thumb.dataset.hsBlob) URL.revokeObjectURL(thumb.dataset.hsBlob);
      var u = URL.createObjectURL(blob);
      thumb.dataset.hsBlob = u;
      thumb.src = u;
      thumb.hidden = false;
    }
    fila.hidden = false;
  }

  /* La espalda sin diseno: queda anotado en el pedido para que no haya dudas. */
  function omitirEspalda(si) {
    if (si) {
      caras.B = caraVacia();
      caras.B.estado = 'omitida';
      ponerArchivo(CAMPOS.B.previa, null);
      ponerTexto(PROP_SIN_TRASERA, 'Sin diseño');
    } else {
      if (caras.B.estado === 'omitida') caras.B.estado = 'ninguno';
      ponerTexto(PROP_SIN_TRASERA, null);
    }
    var nota = document.querySelector('[data-hs-sin-espalda]');
    if (nota) nota.hidden = !si;
    escribirEncuadre();
    refrescarCandado();
  }

  /* Diseno despues: el pedido sale con la nota y el diseno llega por email
     o WhatsApp. Si luego sube un archivo, manda el archivo y se quita la nota. */
  function disenoDespues(si) {
    despues = !!si;
    ponerTexto(PROP_DESPUES, despues ? TXT_DESPUES : null);
    var c = document.querySelector('[data-hs-despues]');
    if (c && c.checked !== despues) c.checked = despues;
    var nota = document.querySelector('[data-hs-despues-nota]');
    if (nota) nota.hidden = !despues;
    refrescarCandado();
  }

  function montarDespues() {
    var box = document.querySelector('[data-hs-uploader]');
    if (!box) return false;
    if (box.querySelector('[data-hs-despues]')) return true;
    var caja = el('div', 'hs-despues');
    var lab = el('label', 'hs-despues__label');
    var c = el('input', 'hs-despues__check');
    c.type = 'checkbox';
    c.setAttribute('data-hs-despues', '');
    c.addEventListener('change', function () { disenoDespues(c.checked); });
    lab.appendChild(c);
    lab.appendChild(el('span', '', 'No tengo el diseño a mano: lo envío después'));
    var nota = el('p', 'hs-despues__nota', 'Haz el pedido ahora y mándanos tu logo por email o WhatsApp. Antes de imprimir te enviamos una prueba digital gratis para que la apruebes.');
    nota.setAttribute('data-hs-despues-nota', '');
    nota.hidden = true;
    caja.appendChild(lab);
    caja.appendChild(nota);
    var err = box.querySelector('[data-hs-error]');
    box.insertBefore(caja, err || null);
    return true;
  }

  function limpiar(cara) {
    caras[cara] = caraVacia();
    ponerArchivo(CAMPOS[cara].previa, null);
    escribirEncuadre();
    refrescarCandado();
    if (modal && !modal.hidden) { pintarModal(); repintar(); }
  }

  /* --- Candado de compra ---------------------------------------------------- */

  function caraLista(k) {
    if (despues) return true;
    var e = caras[k].estado;
    return e === 'listo' || e === 'sin-previa' || e === 'omitida';
  }

  function tallas() {
    try { return window.HSCamOpts ? HSCamOpts.tallas() : { ok: true }; } catch (e) { return { ok: true }; }
  }

  function puedeComprar() {
    return combinacionOk && caraLista('A') && caraLista('B') && tallas().ok;
  }

  function cajaBotones() {
    return document.querySelector('.product-form-buttons');
  }

  function avisoCandado() {
    var caja = cajaBotones();
    if (!caja) return null;
    var n = caja.querySelector('[data-hs-candado]');
    if (!n) {
      n = el('div', 'hs-candado');
      n.setAttribute('data-hs-candado', '');
      var txt = el('span', 'hs-candado__txt', '');
      txt.setAttribute('data-hs-candado-txt', '');
      var b = el('button', 'hs-candado__b', '');
      b.type = 'button';
      b.setAttribute('data-hs-candado-b', '');
      b.addEventListener('click', function () {
        if (caraLista('A') && caraLista('B')) {
          var t = document.querySelector('[data-hs-tallas]');
          if (t && t.scrollIntoView) t.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var i = t && t.querySelector('input');
          if (i) i.focus({ preventScroll: true });
          return;
        }
        API.abrir(caraLista('A') ? 'B' : 'A');
      });
      n.appendChild(txt);
      n.appendChild(b);
      caja.insertBefore(n, caja.firstChild);
    }
    return n;
  }

  function aplicarCandado() {
    var bloqueado = !puedeComprar();

    var add = document.querySelector('button[name="add"]');
    if (add) {
      if (bloqueado) {
        if (!add.dataset.hsLock) add.dataset.hsLock = add.disabled ? 'suyo' : 'nuestro';
        if (!add.disabled) add.disabled = true;
        add.setAttribute('aria-disabled', 'true');
      } else if (add.dataset.hsLock) {
        if (add.dataset.hsLock === 'nuestro') {
          add.disabled = false;
          add.removeAttribute('aria-disabled');
        }
        delete add.dataset.hsLock;
      }
    }

    var express = document.querySelector('.accelerated-checkout-block');
    if (express && express.classList.contains('hs-bloqueado') !== bloqueado) {
      express.classList.toggle('hs-bloqueado', bloqueado);
    }

    var n = avisoCandado();
    if (!n) return;
    if (n.hidden === bloqueado) n.hidden = !bloqueado;
    if (!bloqueado) return;

    var txt = n.querySelector('[data-hs-candado-txt]');
    var b = n.querySelector('[data-hs-candado-b]');
    var mensaje, texto;
    if (!combinacionOk) {
      mensaje = 'Esa combinación no está disponible ahora mismo. Cambia el pack o el color.';
      texto = '';
    } else if (!caraLista('A')) {
      mensaje = caras.A.estado === 'ninguno'
        ? 'Sube tu logo para el pecho o marca «Lo envío después» para añadirlo al carrito.'
        : 'Te falta ajustar el logo del pecho.';
      texto = caras.A.estado === 'ninguno' ? 'Subir mi logo' : 'Ajustar ahora';
    } else if (!caraLista('B')) {
      mensaje = caras.B.estado === 'ninguno'
        ? 'La espalda va incluida: sube el diseño grande o indica que no quieres nada detrás.'
        : 'Te falta ajustar el diseño de la espalda.';
      texto = caras.B.estado === 'ninguno' ? 'Diseño de la espalda' : 'Ajustar espalda';
    } else {
      mensaje = tallas().mensaje || 'Reparte las camisetas por tallas.';
      texto = 'Elegir tallas';
    }
    if (txt && txt.textContent !== mensaje) txt.textContent = mensaje;
    if (b) {
      if (b.textContent !== texto) b.textContent = texto;
      if (b.hidden === !!texto) b.hidden = !texto;
    }
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (puedeComprar()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    aplicarCandado();
    var n = document.querySelector('[data-hs-candado]');
    if (n && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);

  document.addEventListener('click', function (e) {
    if (puedeComprar()) return;
    var t = e.target.closest && e.target.closest('.accelerated-checkout-block, button[name="add"]');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    aplicarCandado();
  }, true);

  var candadoPend = null, moCandado = null;

  function vigilarCandado() {
    var caja = cajaBotones();
    if (!caja) return;
    if (!moCandado) {
      moCandado = new MutationObserver(function () {
        clearTimeout(candadoPend);
        candadoPend = setTimeout(refrescarCandado, 80);
      });
    }
    moCandado.observe(caja, { childList: true, subtree: true });
  }

  function refrescarCandado() {
    if (moCandado) moCandado.disconnect();
    try { aplicarCandado(); } finally { vigilarCandado(); }
  }

  function arrancarCandado() {
    if (!cajaBotones()) return false;
    try { montarDespues(); } catch (e) {}
    refrescarCandado();
    return true;
  }

  if (!arrancarCandado()) {
    var intentos = 0;
    var tmr = setInterval(function () {
      if (arrancarCandado() || ++intentos > 40) clearInterval(tmr);
    }, 250);
  }

  /* Las tallas las lleva el bloque de opciones; avisa al cambiar. */
  document.addEventListener('hs:tallas', refrescarCandado);

  /* --- Anadir al carrito ---------------------------------------------------
     Igual que en pegatinas y llaveros: lo enviamos nosotros, se espera la
     respuesta y se va al carrito. Si falla, se explica y el diseno sigue. */

  var enviando = false;

  function avisoDeError(texto) {
    var f = formularioCompra();
    if (!f) return;
    var n = f.querySelector('[data-hs-error-carrito]');
    if (!n) {
      n = el('p', 'hs-errorcarrito');
      n.setAttribute('data-hs-error-carrito', '');
      var caja = cajaBotones();
      if (caja) caja.insertBefore(n, caja.firstChild);
      else f.appendChild(n);
    }
    n.textContent = texto;
    n.hidden = !texto;
    if (texto && n.scrollIntoView) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function avisoDeEspera(texto) {
    var caja = cajaBotones();
    if (!caja) return;
    var n = caja.querySelector('[data-hs-espera]');
    if (!n) {
      n = el('p', 'hs-espera');
      n.setAttribute('data-hs-espera', '');
      n.setAttribute('role', 'status');
      caja.insertBefore(n, caja.firstChild);
    }
    n.textContent = texto;
    n.hidden = !texto;
  }

  function anadirAlCarrito() {
    var f = formularioCompra();
    if (!f || enviando) return;
    enviando = true;
    avisoDeError('');

    var botones = [].slice.call(document.querySelectorAll('button[name="add"]'));
    botones.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    avisoDeEspera('Subiendo tus diseños…');

    var datos = new FormData(f);
    datos.delete('sections');
    /* Un campo de archivo sin elegir llegaria como adjunto vacio. */
    var vacios = [];
    datos.forEach(function (v, k) { if (v instanceof File && !v.name && !v.size) vacios.push(k); });
    vacios.forEach(function (k) { datos.delete(k); });

    fetch('/cart/add.js', {
      method: 'POST',
      body: datos,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; });
      })
      .then(function (res) {
        if (res.ok && !res.d.status) {
          window.location.href = '/cart';
          return;
        }
        var crudo = (res.d && (res.d.description || res.d.message)) || ('HTTP ' + res.status);
        if (window.console) console.warn('[holasticker] carrito rechazado:', crudo, res.d);
        var msg = 'No hemos podido añadir tu pedido al carrito. '
                + 'Comprueba las opciones y vuelve a intentarlo. '
                + 'Tus diseños siguen guardados.';
        if (/too large|demasiado grande|size/i.test(crudo)) {
          msg = 'El archivo pesa demasiado para enviarlo. Prueba con una imagen más ligera.';
        }
        throw new Error(msg);
      })
      .catch(function (e) {
        enviando = false;
        botones.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
        avisoDeEspera('');
        refrescarCandado();
        avisoDeError(String(e.message || e));
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"]');
    if (!b) return;
    if (!puedeComprar()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    anadirAlCarrito();
  }, true);

  /* --- API ------------------------------------------------------------------ */

  var API = {
    abrir: function (cara) {
      try {
        cara = cara === 'B' ? 'B' : 'A';
        activa = cara;
        if (caras[cara].img) { abrirModal(); return; }
        if (cara === 'B' && caraLista('A')) { abrirModal(); return; }
        var i = inputDe(cara);
        var f = i && i.files && i.files[0];
        if (!f) { if (i) i.click(); return; }
        API.usar(cara, f);
      } catch (e) { if (window.console) console.warn('[holasticker] editor:', e); }
    },

    usar: function (cara, file) {
      try {
        if (cara === 'B') omitirEspalda(false);
        if (despues) disenoDespues(false);
        var d = caras[cara];
        d.nombre = file ? file.name : '';
        cargar(file).then(function (i) {
          d.img = i;
          d.guardado = false;
          d.estado = 'pendiente';
          d.t = { escala: 1, x: 0, y: 0, giro: 0 };
          ponerArchivo(CAMPOS[cara].previa, null);
          refrescarCandado();
          activa = cara;
          abrirModal();
        }).catch(function () {
          caras[cara] = caraVacia();
          caras[cara].nombre = d.nombre;
          caras[cara].estado = 'sin-previa';
          ponerArchivo(CAMPOS[cara].previa, null);
          refrescarCandado();
          var err = document.querySelector('[data-hs-uploader] [data-hs-error]');
          if (err) {
            err.textContent = 'Ese archivo se envía igual, pero no podemos mostrarte la vista previa. Si quieres verla, sube un PNG o un JPG.';
            err.hidden = false;
          }
          if (modal && !modal.hidden) pintarModal();
        });
      } catch (e) { if (window.console) console.warn('[holasticker] editor:', e); }
    },

    combinacion: function (hay) {
      if (combinacionOk === !!hay) return;
      combinacionOk = !!hay;
      refrescarCandado();
    },
    limpiar: limpiar,
    omitirEspalda: omitirEspalda,
    disenoDespues: disenoDespues
  };

  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('[data-hs-group]');
    if (!r) return;
    if (r.dataset.hsGroup === 'color') {
      if (modal && !modal.hidden) { pintarModal(); repintar(); }
      regenerar();
    } else if (r.dataset.hsGroup === 'pack') {
      refrescarCandado();
      if (modal && !modal.hidden) pintarModal();
    }
  });

  window.HSCamiseta = API;
})();
